let stripeScript

// Keep Pix's Stripe instance independent of the existing global card plugin.
export default async function loadPixStripe(publishableKey) {
  if (!publishableKey) throw new Error('Missing Stripe publishable key')
  if (!window.Stripe) {
    if (!stripeScript) {
      stripeScript = new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = 'https://js.stripe.com/v3/'
        script.async = true
        const timeout = setTimeout(() => {
          script.remove()
          stripeScript = null
          reject(new Error('Stripe could not be loaded'))
        }, 15000)
        script.onload = () => {
          clearTimeout(timeout)
          resolve()
        }
        script.onerror = () => {
          clearTimeout(timeout)
          script.remove()
          stripeScript = null
          reject(new Error('Stripe could not be loaded'))
        }
        document.head.appendChild(script)
      })
    }
    await stripeScript
  }
  if (!window.Stripe) throw new Error('Stripe is unavailable')
  return window.Stripe(publishableKey, { locale: 'auto' })
}
